import { bemClassNames } from "@multiweb/reactUtils";

export const ROLE_USERS_ATTRIBUTE_CLASS_NAME = bemClassNames("role-users-attribute");
